import React$1, { useContext } from 'react';
import CloseIcon from '../../basics/Icon/svgs/navClose.js';
import Right from '../../basics/Icon/svgs/rightSmall.js';
import { extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';
import PropTypes$1 from 'prop-types';
import Link$1 from '../../basics/Link/Link.js';
import Logo$1 from '../../basics/Logo/Logo.js';
import StyledNavigation from './Navigation.style.js';
import { NavigationContext } from '../../contexts/NavigationProvider/NavigationProvider.js';

const Navigation = ({
  className,
  homeLink,
  mainLinks
}) => {
  const {
    isOpen,
    activePrimaryNavItem,
    toggleNavigation,
    setActivePrimaryNavigation,
    resetPrimaryNavigation,
    listRef
  } = useContext(NavigationContext);
  return /*#__PURE__*/React$1.createElement(StyledNavigation, {
    className: className,
    isOpen: isOpen,
    activePrimaryNavItem: activePrimaryNavItem
  }, /*#__PURE__*/React$1.createElement("button", {
    type: "button",
    className: "navigation__button--mobile",
    onClick: () => toggleNavigation()
  }, isOpen ? /*#__PURE__*/React$1.createElement("div", {
    className: "navigation__button--close"
  }, /*#__PURE__*/React$1.createElement(CloseIcon, null)) : /*#__PURE__*/React$1.createElement("div", {
    className: "navigation__button--open"
  }, /*#__PURE__*/React$1.createElement("span", null), /*#__PURE__*/React$1.createElement("span", null), /*#__PURE__*/React$1.createElement("span", null))), /*#__PURE__*/React$1.createElement("div", {
    className: "navigation__wrapper"
  }, /*#__PURE__*/React$1.createElement("div", {
    className: "navigation__inner"
  }, /*#__PURE__*/React$1.createElement("div", {
    className: "navigation__list",
    ref: listRef
  }, /*#__PURE__*/React$1.createElement("div", {
    className: "navigation__logo--container"
  }, /*#__PURE__*/React$1.createElement(Link$1, _extends({}, homeLink, {
    "aria-label": "Home",
    noHover: true,
    className: "navigation__logo"
  }), /*#__PURE__*/React$1.createElement(Logo$1, {
    inline: true,
    transition: {
      property: 'fill',
      delay: '300ms'
    }
  }))), /*#__PURE__*/React$1.createElement("div", {
    className: "navigation__list-wrapper"
  }, /*#__PURE__*/React$1.createElement("button", {
    type: "button",
    className: "navigation__button--back",
    onClick: () => resetPrimaryNavigation()
  }, /*#__PURE__*/React$1.createElement(Right, null), "Back"), /*#__PURE__*/React$1.createElement("ul", {
    className: "navigation__mainlist--mobile"
  }, mainLinks.map(link => link.subLinks && link.subLinks.length > 0 ? /*#__PURE__*/React$1.createElement("li", {
    key: link.label
  }, /*#__PURE__*/React$1.createElement("button", {
    type: "button",
    className: `navigation__button--primary ${link.isActive ? 'navigation__button--active' : ''}`,
    onClick: () => setActivePrimaryNavigation(link.label)
  }, link.label)) : /*#__PURE__*/React$1.createElement("li", {
    key: link.label
  }, /*#__PURE__*/React$1.createElement(Link$1, _extends({}, link, {
    icon: null,
    noHover: true,
    className: link.isActive ? 'is-active' : ''
  }), /*#__PURE__*/React$1.createElement("span", null, link.label))))), /*#__PURE__*/React$1.createElement("ul", {
    className: "navigation__mainlist"
  }, mainLinks.map(link => link && link.label && /*#__PURE__*/React$1.createElement("li", {
    key: link.label,
    "data-primary-label": link.label.replace(/\s/g, '')
  }, /*#__PURE__*/React$1.createElement(Link$1, _extends({}, link, {
    icon: null,
    noHover: true,
    className: link.isActive ? 'is-active' : ''
  }), /*#__PURE__*/React$1.createElement("span", null, link.label), /*#__PURE__*/React$1.createElement(Right, null)), link.subLinks && link.subLinks.length > 0 && /*#__PURE__*/React$1.createElement("div", {
    className: "navigation__sublist"
  }, /*#__PURE__*/React$1.createElement("div", {
    className: "navigation__sublist--container"
  }, /*#__PURE__*/React$1.createElement("ul", {
    className: "navigation__sublist--inner"
  }, link.subLinks.map(sublink => sublink && /*#__PURE__*/React$1.createElement("li", {
    key: sublink.label
  }, /*#__PURE__*/React$1.createElement(Link$1, _extends({}, sublink, {
    icon: null,
    noHover: true,
    className: sublink.isActive ? 'is-active' : ''
  }), /*#__PURE__*/React$1.createElement("span", null, sublink.label)))))))))))))));
};

Navigation.propTypes = {
  className: PropTypes$1.string,
  homeLink: PropTypes$1.shape().isRequired,
  mainLinks: PropTypes$1.arrayOf(PropTypes$1.shape()).isRequired
};
Navigation.defaultProps = {
  className: ''
};

export default Navigation;
